import { CURRENT_AWARD_YEAR } from 'constants/evaluation';

/**
 * Returns the parsed close date for submissions.
 * Prioritizes import.meta.env.VITE_SUBMISSION_CLOSE_DATE.
 * Defaults to June 30th of the current award year at 23:59:00.
 */
export const getCloseDate = (): Date => {
  const envCloseDate = import.meta.env.VITE_SUBMISSION_CLOSE_DATE;
  if (envCloseDate) {
    const parsed = new Date(envCloseDate);
    if (!isNaN(parsed.getTime())) {
      return parsed;
    }
  }

  // June is month index 5 (0-indexed: Jan=0, Feb=1, etc.)
  // Default is June 30, 23:59:00 of the CURRENT_AWARD_YEAR
  return new Date(CURRENT_AWARD_YEAR, 5, 30, 23, 59, 0);
};

/**
 * Checks if the submission is closed relative to the provided timestamp or the current time.
 */
export const checkSubmissionClosed = (now: Date = new Date()): boolean => {
  const closeDate = getCloseDate();
  return now > closeDate;
};

/**
 * Checks if the submission is closed at the current time.
 */
export const isSubmissionClosed = (): boolean => {
  return checkSubmissionClosed();
};
